// Packages
import React, { useContext, useEffect } from 'react';
import { UserContext } from '@services/Session';

// Components
import { Box } from 'grommet';

// Types
import { PaywallEvents, PaywallLockProps } from './paywall.types';
import SHDThemeOverride from '@ui/ThemeOverride/SHDThemeOverride';

import PaywallAccessUpsell from './components/PaywallAccessUpsell';
import PaywallLockDisplay from './components/PaywallLockDisplay';
import { usePaywallTracking } from '@hooks/revcat/usePaywallTracking';

const PaywallLock: React.FC<PaywallLockProps> = ({
  isClaimed = true,
  isPrivate = false,
  context,
  handlePaywallOpen,
  playerId,
  customCopy = null,
}) => {
  const { trackPaywallEvent } = usePaywallTracking(context, playerId);

  const userStore = useContext(UserContext);
  const isLoggedIn = !!userStore.authUser;

  const handleCtaClick = () => {
    trackPaywallEvent(PaywallEvents.VIEW_PLANS_CLICKED, {
      context: context,
    });
    handlePaywallOpen();
  };

  useEffect(() => {
    trackPaywallEvent(PaywallEvents.PAYWALL_DISPLAYED, {
      context: context,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SHDThemeOverride full={false}>
      <Box
        align="center"
        className="paywall-lock"
        direction="column"
        style={{ position: 'relative' }}
      >
        {!isLoggedIn || isPrivate ? (
          <PaywallLockDisplay isLoggedIn={isLoggedIn} context={context} />
        ) : (
          <PaywallAccessUpsell
            onClick={handleCtaClick}
            isLoggedIn={isLoggedIn}
            isClaimed={isClaimed}
            customCopy={customCopy}
          />
        )}
      </Box>
    </SHDThemeOverride>
  );
};

export default PaywallLock;
